export default "__VITE_ASSET__CTmlVABl__"